module.exports = "fragment HotlineQuestion on HotlineQuestionType{__typename id rowId text alliance first}"